<div class="tooltip-content" [class.tw-invisible]="hideMe$ | async" [@tooltipAnimation] role="tooltip">
  <div class="tooltip-arrow"></div>
  <div class="tooltip-inner" [innerHTML]="tip$ | async"></div>
</div>